import {
  INIT_GLOBALS,
  INIT_POSTS_PAGE_ROUTINE,
  UPDATE_POSTS_PAGE_NAME,
} from "constants/ActionTypes";
import { createReducer } from "@reduxjs/toolkit";

const initialState = "";

const changePage = (state, action) => {
  const { page } = action.payload;

  if (page) {
    state = page;
  }

  return state;
};

export const pageReducer = createReducer(initialState, (builder) => {
  builder.addCase(INIT_GLOBALS, changePage);
  builder.addCase(UPDATE_POSTS_PAGE_NAME, changePage);
  builder.addCase(INIT_POSTS_PAGE_ROUTINE.TRIGGER, changePage);
});
